import l10n from "diy/util/l10n";

import AlertWarningIcon from "material-ui/svg-icons/alert/warning";

let domainpromo: any = require("diy/domainpromo/domainpromo");

import Type from "../definitions/Type";
import Severity from "../definitions/Severity";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.NO_DOMAIN,

    testId: "no-domain",
    trackingId: "NoDomainNotification",

    content: l10n("domainConnection.notification.infoText"),
    icon: AlertWarningIcon,
    severity: Severity.HIGH,

    mainAction: {
        testId: "show-domain-promo",
        label: l10n("notifications.moreDetails"),
        onClick: () => {
            domainpromo.show();
        }
    },

    cardOptions: {
        closable: false
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/NoDomain.ts
 **/